import React from "react"
import {ReactComponent as EmptyIcon} from "../assets/icons/checkbox/checkbox_empty.svg"
import {ReactComponent as CheckedIcon} from "../assets/icons/checkbox/checkbox_checked.svg"

export default function Checkbox({checked, onChange, disabled = false, ...props}) {
  checked = !!checked
  disabled = !!disabled

  const {className} = props

  const classNames = ["da-checkbox"]
  if (className != null) classNames.push(className)

  const handleChange = () => {
    if (onChange) {
      onChange(!checked)
    }
  }

  return (
    <label className={classNames.join(" ")} data-disabled={disabled || undefined}>
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={handleChange}
        className="da-checkbox-input"
      />
      {checked ? <CheckedIcon/> : <EmptyIcon/>}
    </label>
  )
}
